module.exports = __webpack_public_path__ + "static/media/cedomir.bbc4db63.jpg";